/**
 * Module-level storage for impersonated tenant ID.
 * Used by apiClient to add X-Tenant-Id header when root users impersonate a tenant.
 * Synced from TenantSwitcherContext when activeTenant changes.
 */
let impersonatedTenantId: string | null = null;

export function getImpersonatedTenantId(): string | null {
  return impersonatedTenantId;
}

export function setImpersonatedTenantId(tenantId: string | null): void {
  impersonatedTenantId = tenantId;
}
